export default {"src":"/_next/static/media/m_logo.3568b33c.svg","height":34,"width":35,"blurWidth":0,"blurHeight":0};